import React from 'react';
import * as d3 from 'd3';

import { alignAxis } from 'utils/chartUtils';
import Axis from './Axis';
import Dots from './Dots';
import Line from './Line';
import style from './Chart.module';

const SpO2Chart = ({
  data = [],
  dimensions,
  xData,
  tz = {},
  axisAmount,
  axisIndex,
}) => {
  if (!data.length) return null;
  const xAccessor = d => d.time;
  const yAccessor = d => d.value;
  const keyAccessor = (_, i) => i;

  const lowerXRange = axisAmount > 1 ? 30 : 0;

  const xScale = d3
    .scaleTime()
    .domain(d3.extent(xData))
    .range([lowerXRange, dimensions.boundedWidth]);

  const yScale = d3
    .scaleLinear()
    .domain([0.3, 1])
    .range([dimensions.boundedHeight, 0])
    .nice();

  const xAccessorScaled = d => xScale(xAccessor(d));
  const yAccessorScaled = d => yScale(yAccessor(d));

  const axisAligment = alignAxis(axisIndex, axisAmount);

  return [
    <Axis
      key="hr-y-axis"
      dimension="y"
      scale={yScale}
      tickColor={style.spo2Label}
      labelLine
      formatTick={tick => tick * 100}
      {...axisAligment}
    />,
    <Line
      style={{ ...style.line, ...style.spo2Line }}
      data={data}
      xAccessor={xAccessorScaled}
      yAccessor={yAccessorScaled}
      interpolation={d3.curveLinear}
    />,
    <Dots
      style={style.spo2Circles}
      data={data}
      keyAccessor={keyAccessor}
      xAccessor={xAccessorScaled}
      yAccessor={yAccessorScaled}
      radius={4}
      tz={tz}
    />,
  ];
};

const SpO2ChartDayTrend = ({
  data = [],
  dimensions,
  xData,
  tz,
  axisAmount,
}) => {
  if (!data.length) return null;
  const xAccessor = d => d.time;
  const yAccessor = d => d.value;
  const keyAccessor = (_, i) => i;

  const lowerXRange = axisAmount > 1 ? 30 : 0;

  const xScale = d3
    .scaleTime()
    .domain(d3.extent(xData))
    .range([lowerXRange, dimensions.boundedWidth]);

  const yScale = d3
    .scaleLinear()
    .domain([0.3, 1])
    .range([dimensions.boundedHeight, 0])
    .nice();

  const xAccessorScaled = d => xScale(xAccessor(d));
  const yAccessorScaled = d => yScale(yAccessor(d));

  return [
    <Axis
      key="hr-y-axis"
      dimension="y"
      scale={yScale}
      tickColor={style.spo2Label}
      labelLine
      formatTick={tick => tick * 100}
    />,
    data.length !== 1 ? (
      <Line
        style={style.spo2LineTrend}
        data={data}
        xAccessor={xAccessorScaled}
        yAccessor={yAccessorScaled}
        interpolation={d3.curveLinear}
      />
    ) : (
      <Dots
        style={style.spo2Circles}
        data={data}
        keyAccessor={keyAccessor}
        xAccessor={xAccessorScaled}
        yAccessor={yAccessorScaled}
        radius={4}
        tz={tz}
      />
    ),
  ];
};

export { SpO2Chart, SpO2ChartDayTrend };
